<sdx-toolbar [data]="cueContent.navigation"></sdx-toolbar>
<sdx-navigation [data]="cueContent.navigation"></sdx-navigation>
